export default "__VITE_ASSET__ft4Y$24S__"